import { useReadyValue } from '@finn/platform-modules';
import {
  CookieKeys,
  getClientBooleanCookie,
  setClientBooleanCookie,
} from '@finn/ui-utils';

const EXPIRATION_DAYS = 30;

export const setForBusinessCookie = (value: boolean) =>
  setClientBooleanCookie(CookieKeys.IS_FOR_BUSINESS, value, EXPIRATION_DAYS);

export const getForBusinessCookie = () =>
  getClientBooleanCookie(CookieKeys.IS_FOR_BUSINESS);

export const useForBusinessCookie = () => {
  return useReadyValue(getForBusinessCookie(), false);
};

export const setMonthlyPaymentOfServiceFeeCookie = (value: boolean) =>
  setClientBooleanCookie(
    CookieKeys.MONTHLY_PAYMENT_OF_SERVICE_FEE,
    value,
    EXPIRATION_DAYS
  );

export const getMonthlyPaymentOfServiceFeeCookie = () =>
  getClientBooleanCookie(CookieKeys.MONTHLY_PAYMENT_OF_SERVICE_FEE);

export const useMonthlyWithServiceFeeCookie = () => {
  return useReadyValue(getMonthlyPaymentOfServiceFeeCookie(), false);
};
